import character_frame from 'art/character_frame.png';
import cullen from 'art/cullen.png';
import cullen_vamp from 'art/cullen_vamp.png';
// Characters
// TODO: rename file
import garlic_farmer_framed1 from 'art/garlic_farmer_framed1.png';
import librarian_framed1 from 'art/librarian_framed1.png';
import librarian_framed2 from 'art/librarian_framed2.png';
import mayor_framed1 from 'art/mayor_framed1.png';
import mayor_framed2 from 'art/mayor_framed2.png';
import priest_framed1 from 'art/priest_framed1.png';
import priest_framed2 from 'art/priest_framed2.png';
import vampire from 'art/vampire.png';
import vampire2 from 'art/vampire2.png';
import death_mode_desktop from 'art/death_mode_desktop.png';
import human from 'art/human.png';
import ashes2 from 'art/ashes2.png';
import cullen_ashes from 'art/cullen_ashes.png';
import { roles } from 'core/constants';
import React from 'react';
import styled from 'styled-components';

const {
  GARLIC_FARMER,
  PRIEST,
  LIBRARIAN,
  MAYOR,
  CULLEN,
  VAMPIRE,
  HUMAN,
} = roles;

const scale = 1.5;

const imageWidthRem = 13;
const imageWidthRemLarge = 15;
const CharacterFrame = styled.img.attrs(() => ({
  src: character_frame,
  alt: 'Frame with vampire teeth designs',
}))`
  width: ${(props) => props.scale * imageWidthRem}vw;
  height: auto;
  position: absolute;
`;
const DeathMode = styled.img.attrs(() => ({
  src: death_mode_desktop,
  alt: 'Transparent curtain draped over frame',
}))`
  width: ${(props) => props.scale * 21.25}vw;
  height: auto;
  position: absolute;
  top: ${(props) => props.scale * -1.8}vw;
  z-index: 2;
`;

const CharacterContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: ${(props) => props.scale * imageWidthRem}vw;
  height: ${(props) => props.scale * imageWidthRem * 1.25}vw;
`;

const GarlicFarmer = styled.img.attrs(() => ({
  src: garlic_farmer_framed1,
  alt: 'Garlic Farmer',
}))`
  margin-top: ${(props) => props.scale * 0.4063}vw;
  margin-left: ${(props) => props.scale * 0.25}vw;
  width: ${(props) => props.scale * imageWidthRem}vw;
  height: auto;
  position: absolute;
`;

const Priest = styled.img.attrs(() => ({
  src: priest_framed1,
  alt: 'Priest',
}))`
  margin-top: 0px;
  margin-left: 0px;
  width: ${(props) => props.scale * imageWidthRem}vw;
  height: auto;
  position: absolute;
`;

const Priest2 = styled.img.attrs(() => ({
  src: priest_framed2,
  alt: 'Priest',
}))`
  margin-top: 0.425vw;
  margin-left: 0.375vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;

const Librarian = styled.img.attrs(() => ({
  src: librarian_framed1,
  alt: 'Librarian',
}))`
  margin-top: ${(props) => props.scale * -0.875}vw;
  margin-left: ${(props) => props.scale * 0.1875}vw;
  width: ${(props) => props.scale * imageWidthRem}vw;
  height: auto;
  position: absolute;
`;

const Librarian2 = styled.img.attrs(() => ({
  src: librarian_framed2,
  alt: 'Librarian',
}))`
  margin-top: ${(props) => props.scale * 0.375}vw;
  margin-left: ${(props) => props.scale * 0.75}vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;

const Mayor = styled.img.attrs(() => ({
  src: mayor_framed1,
  alt: 'Mayor',
}))`
  margin-top: ${(props) => props.scale * -0.5313}vw;
  margin-left: ${(props) => props.scale * -0.0625}vw;
  width: ${(props) => props.scale * imageWidthRem}vw;
  height: auto;
  position: absolute;
`;
const Mayor2 = styled.img.attrs(() => ({
  src: mayor_framed2,
  alt: 'Mayor',
}))`
  margin-top: ${(props) => props.scale * 0.5625}vw;
  margin-left: ${(props) => props.scale * 0.625}vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;

const Cullen = styled.img.attrs(() => ({
  src: cullen,
  alt: 'Cullen Turned Vampire',
}))`
  margin-top: ${(props) => props.scale * 0.375}vw;
  margin-left: ${(props) => props.scale * 0.4375}vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;
const VampCullen = styled.img.attrs(() => ({
  src: cullen_vamp,
  alt: 'Cullen Turned Vampire',
}))`
  margin-top: ${(props) => props.scale * 1.1563}vw;
  margin-left: 0px;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;
const Vampire = styled.img.attrs(() => ({
  src: vampire,
  alt: 'Vampire',
}))`
  margin-top: ${(props) => props.scale * 0.4063}vw;
  margin-left: ${(props) => props.scale * -0.125}vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;
const Human = styled.img.attrs(() => ({
  src: human,
  alt: 'Human',
}))`
  margin-top: ${(props) => props.scale * 0.5625}vw;
  margin-left: ${(props) => props.scale * -0.125}vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;

const Vampire2 = styled.img.attrs(() => ({
  src: vampire2,
  alt: 'Vampire',
}))`
  margin-top: ${(props) => props.scale * 0.4688}vw;
  margin-left: ${(props) => props.scale * 0.12}vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;

const Ashes = styled.img.attrs(() => ({
  src: ashes2,
  alt: 'Ashes with Word Staked',
}))`
  margin-top: 0.425vw;
  margin-left: ${(props) => props.scale * 0.5625}vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;

const CullenAshes = styled.img.attrs(() => ({
  src: cullen_ashes,
  alt: "Cullen's Ashes",
}))`
  margin-top: ${(props) => props.scale * 0.4375}vw;
  margin-left: ${(props) => props.scale * 0.75}vw;
  width: ${(props) => props.scale * imageWidthRemLarge}vw;
  height: auto;
  position: absolute;
`;

const CharacterImages = {
  [GARLIC_FARMER]: GarlicFarmer,
  [PRIEST]: Priest,
  [PRIEST + 2]: Priest2,
  [LIBRARIAN]: Librarian,
  [LIBRARIAN + 2]: Librarian2,
  [MAYOR]: Mayor,
  [MAYOR + 2]: Mayor2,
  [CULLEN]: Cullen,
  [VAMPIRE]: Vampire,
  [VAMPIRE + 2]: Vampire2,
  [VAMPIRE + 3]: VampCullen,
  [HUMAN]: Human,
  ashes: Ashes,
  cullenAshes: CullenAshes,
};

const Character = ({ role, isExpired, scale = 1 }) => {
  let CharacterImage = CharacterImages[role];
  const isUndead = role.includes(CULLEN) || role.includes(VAMPIRE);
  if (isUndead && isExpired) {
    if (role === CULLEN) {
      CharacterImage = CullenAshes;
    } else {
      CharacterImage = Ashes;
    }
  }
  return (
    <CharacterContainer scale={scale}>
      <CharacterFrame scale={scale} />
      {!isUndead && <DeathMode hidden={!isExpired} scale={scale} />}
      {CharacterImage && <CharacterImage scale={scale} />}
    </CharacterContainer>
  );
};

export default Character;
